import { useEffect, useState } from 'react';
import { sharedDb } from '@/lib/supabase';
import { useAuth } from '@/hooks/useAuth';
import type { Building } from '@/types';

export function BuildingsPage() {
  const { tenantId } = useAuth();
  const [buildings, setBuildings] = useState<Building[]>([]);
  const [loading, setLoading] = useState(true);
  const [q, setQ] = useState('');

  useEffect(() => {
    if (!tenantId) return;
    (async () => {
      const { data } = await sharedDb()
        .from('buildings')
        .select('*')
        .order('name')
        .limit(200);
      setBuildings((data ?? []) as unknown as Building[]);
      setLoading(false);
    })();
  }, [tenantId]);

  const filtered = q
    ? buildings.filter((b) => b.name.includes(q) || (b.address ?? '').includes(q))
    : buildings;

  return (
    <div>
      <header className="sticky top-0 z-10 border-b border-slate-200 bg-white/95 px-4 py-3 backdrop-blur">
        <h1 className="text-sm font-semibold">建物</h1>
        <input
          type="search"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="建物名・住所で検索"
          className="mt-2 block w-full rounded-md border border-slate-200 px-3 py-2 text-sm"
        />
      </header>
      {loading ? (
        <div className="p-6 text-sm text-slate-500">読み込み中...</div>
      ) : filtered.length === 0 ? (
        <div className="p-6 text-sm text-slate-500">建物がまだ登録されていません。</div>
      ) : (
        <ul className="divide-y divide-slate-100">
          {filtered.map((b) => (
            <li key={b.id} className="px-4 py-3">
              <div className="text-sm font-medium">{b.name}</div>
              <div className="mt-0.5 text-[10px] text-slate-500">
                {b.address ?? '住所未登録'}
                {b.address_verified && <span className="ml-2">✓ 検証済</span>}
              </div>
              {b.google_maps_url && (
                <a href={b.google_maps_url} target="_blank" rel="noreferrer" className="mt-1 inline-block text-[10px] text-emerald-700 underline">
                  Google Maps →
                </a>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
